import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { AdvisorGroupId, AdvisorId, ServiceTeamId, } from "../../Types";
import ValidationError from "../../ZodError";
export const ServiceTeamType = z.enum(["Global", "Regular"]);
export const ServiceTeam = z.object({
    serviceTeamId: ServiceTeamId,
    name: z.string(),
    members: AdvisorId.array(),
    leads: AdvisorId.array(),
    type: ServiceTeamType,
    advisors: AdvisorId.array(),
    advisorGroups: AdvisorGroupId.array(),
    institution: z.string(),
});
export const ServiceTeamsResponse = z.array(ServiceTeam);
export const serviceTeamsUrl = () => {
    return environment() === "PROD"
        ? "https://middleware.prod.farther.com/entity/service-team"
        : "https://middleware.uat.farther.com/entity/service-team";
};
export default async function getServiceTeams(config) {
    const { data } = await axios.get(serviceTeamsUrl(), {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
            Version: "20241007",
        },
    });
    const decoded = ServiceTeamsResponse.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[getServiceTeams] Could not parse";
        errorLog("getServiceTeams", JSON.stringify(decoded.error.issues));
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getServiceTeams.js.map